import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icon/historyOrange.svg'
import _imports_1 from '@/assets/img/icon/payKlaimGreen.svg'
import _imports_2 from '@/assets/img/icon/invoiceRed.svg'


const _hoisted_1 = { id: "claim-and-payment" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Klaim Dan Pembayaran Agen")
], -1)
const _hoisted_4 = { class: "color-primary font-semibold" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = {
  key: 0,
  class: "flex w-full justify-between px-5",
  style: {"border-left":"1px solid #ECEFF1"}
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "mr-2 w-4 h-4"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "color-primary" }, "History", -1)
const _hoisted_9 = {
  class: "flex w-full justify-between items-center px-2 pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_10 = /*#__PURE__*/_createVNode("h6", { class: "font-semibold text-xl text-black" }, /*#__PURE__*/_toDisplayString('Histoy Klaim Dan Pembayaran'), -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "mr-2" }, "Tanggal :", -1)
const _hoisted_13 = { class: "rounded-lg px-4 py-4 background-orange-lighten-5 mx-2 mb-4" }
const _hoisted_14 = { class: "font-bold color-primary mb-1" }
const _hoisted_15 = { class: "flex w-full justify-between" }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "color-primary" }, /*#__PURE__*/_toDisplayString('Total Klaim Saat Ini'), -1)
const _hoisted_17 = { class: "font-bold color-primary" }
const _hoisted_18 = {
  key: 0,
  class: "px-1"
}
const _hoisted_19 = {
  class: "flex",
  style: {"width":"20%"}
}
const _hoisted_20 = {
  key: 0,
  src: _imports_1,
  class: "w-8 h-8"
}
const _hoisted_21 = {
  key: 1,
  src: _imports_2,
  class: "w-8 h-8"
}
const _hoisted_22 = {
  class: "",
  style: {"width":"55%"}
}
const _hoisted_23 = { class: "color-blue-grey text-sm" }
const _hoisted_24 = {
  class: "flex justify-end",
  style: {"width":"25%"}
}
const _hoisted_25 = {
  key: 1,
  class: "color-blue-grey font-medium text-sm px-4 py-3 text-center"
}
const _hoisted_26 = { class: "p-col-12 block" }
const _hoisted_27 = { class: "btn-action w-full flex justify-end mt-5" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Clear Filter")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Card = _resolveComponent("Card")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_ClaimAndPaymentForm = _resolveComponent("ClaimAndPaymentForm")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, { class: "h-full" }, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", null, [
            _createVNode(_component_InputIconRightGrey, {
              placeholder: "Cari Disini ...",
              type: _ctx.$enumBase.input.text,
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputSearch = $event)),
              canClick: true,
              onSubmitInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getAllData(_ctx.inputSearch))),
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.getAllData(_ctx.inputSearch)), ["enter"])),
              icon: _ctx.$icon.svg.searchEva
            }, null, 8, ["type", "modelValue", "icon"])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          value: _ctx.data,
          class: "table-og",
          responsiveLayout: "scroll"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "Nama Agen",
              style: {"width":"30%"}
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_4, _toDisplayString(slotProps.data.NamaAgen), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Kota",
              field: "KotaAgen",
              style: {"width":"30%"}
            }),
            _createVNode(_component_Column, {
              header: "Total Klaim",
              style: {"width":"20%"}
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_5, " Rp. " + _toDisplayString(new Number(slotProps.data.Total).toLocaleString("id-ID")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { style: {"width":"20%","min-width":"150px"} }, {
              body: _withCtx((slotProps) => [
                (_ctx.route.meta.permission.write)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      (_ctx.checkPermission(_ctx.PermissionEnum.ShowHisClaim))
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: "flex items-center cursor-pointer",
                            onClick: ($event: any) => (_ctx.showingHistory(slotProps.data))
                          }, [
                            _hoisted_7,
                            _hoisted_8
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode("i", {
                        class: "pi pi-ellipsis-h text-base cursor-pointer text-black font-bold ml-auto",
                        "aria:haspopup": "true",
                        onClick: ($event: any) => (_ctx.showDropDown($event, slotProps.data))
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        (_ctx.data.length > 0)
          ? (_openBlock(), _createBlock(_component_Paginator, {
              key: 0,
              rows: _ctx.$numbers.totalItemPerPage,
              totalRecords: _ctx.filters.totalRecords,
              onPage: _ctx.onPage
            }, null, 8, ["rows", "totalRecords", "onPage"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          payKlaim: _ctx.route.meta.permission.update,
          addKlaim: _ctx.route.meta.permission.update,
          onPayKlaim: _cache[4] || (_cache[4] = ($event: any) => (_ctx.paymentKlaim(_ctx.dataEdit))),
          onAddKlaim: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addedKlaimAgent(_ctx.dataEdit)))
        }, null, 8, ["payKlaim", "addKlaim"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Sidebar, {
      class: "type-bus-sidebar",
      visible: _ctx.sliderActive,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.sliderActive = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ClaimAndPaymentForm, {
          dataEdit: _ctx.dataEdit,
          onReloadData: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getAllData())),
          onCloseSidebar: _ctx.closeSidebar,
          isPaymentKlaim: _ctx.isPaymentKlaim
        }, null, 8, ["dataEdit", "onCloseSidebar", "isPaymentKlaim"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showDialogHistory,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_ctx.showDialogHistory = $event)),
      class: "dialog-voucher",
      modal: true,
      dismissableMask: true
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("i", {
            class: "pi pi-times text-black cursor-pointer",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.hideDialogHistory()))
          })
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.dataEdit)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode("div", {
                class: "mb-2 flex items-center mx-2",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showFilterDate($event)))
              }, [
                _hoisted_12,
                _createVNode("p", {
                  class: `${(_ctx.dateFilter) ? 'font-bold' : 'color-blue-grey font-medium'} cursor-pointer`
                }, _toDisplayString((_ctx.dateFilter) ? _ctx.moment(_ctx.dateFilter).format('DD MMM YYYY') : 'Pilih Tanggal'), 3)
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("p", _hoisted_14, _toDisplayString(_ctx.dataEdit.NamaAgen), 1),
                _createVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode("p", _hoisted_17, "Rp. " + _toDisplayString(new Number(_ctx.dataEdit.Total).toLocaleString("id-ID")), 1)
                ])
              ]),
              (_ctx.dataHistory.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_18, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataHistory, (item) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "flex px-3 py-4 items-center",
                        style: {"border-bottom":"1px solid #CFD8DC"},
                        key: item.Id
                      }, [
                        _createVNode("div", _hoisted_19, [
                          _createVNode("div", {
                            class: ["flex rounded-full p-3", _ctx.colorAndBgHistory(item.IsPayment).bg]
                          }, [
                            (item.IsPayment)
                              ? (_openBlock(), _createBlock("img", _hoisted_20))
                              : (_openBlock(), _createBlock("img", _hoisted_21))
                          ], 2)
                        ]),
                        _createVNode("div", _hoisted_22, [
                          _createVNode("p", {
                            class: ["font-bold mb-1", _ctx.colorAndBgHistory(item.IsPayment).color]
                          }, _toDisplayString(item.IsPayment ? 'Pembayaran Klaim' : 'Klaim Agen'), 3),
                          _createVNode("p", _hoisted_23, _toDisplayString(_ctx.moment(item.TanggalKlaim).format('DD MMMM YYYY, HH:mm')) + " WIB", 1)
                        ]),
                        _createVNode("div", _hoisted_24, [
                          _createVNode("p", {
                            class: ["font-bold", _ctx.colorAndBgHistory(item.IsPayment).color]
                          }, _toDisplayString(item.IsPayment ? '-' : '+') + " Rp. " + _toDisplayString(new Number(item.Nominal).toLocaleString("id-ID")), 3)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock("p", _hoisted_25, "Data history tidak ditemukan"))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_OverlayPanel, {
      ref: "filterCal",
      id: "filter_overlay_panel",
      class: "p-5 calendar-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode("span", _hoisted_26, [
          _createVNode(_component_Calendar, {
            modelValue: _ctx.dateFilter,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dateFilter = $event)),
            inline: true,
            showWeek: true
          }, null, 8, ["modelValue"]),
          _createVNode("div", _hoisted_27, [
            (_ctx.dateFilter)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Filter",
                  class: "font-semibold p-button-sm btn-primary px-10 mr-2",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveFilterDate()))
                }))
              : _createCommentVNode("", true),
            (_ctx.sendDateFilter !== null)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "btn-secondary text-black p-button-sm px-10 py-1",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.clearFilter()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}